<template>
  <div class="mt-5 flex items-center justify-between">
    <div class="basis-1/2 pt-6 text-sm font-semibold text-gray-400 xl:pt-0">
      <div class="flex items-center no-localize-translate">
        <h1 class="text-xl text-slate-900 md:text-3xl 2xl:text-5xl">
          {{ totalEmissions }}
        </h1>
        <span class="ml-2">tCO2e</span>
      </div>
      <div class="mt-0.5 whitespace-nowrap">
        <span
          :class="[
            previousYearMetricsChange === 0
              ? 'text-gray-400'
              : previousYearMetricsChange > 0
                ? 'text-red-500'
                : 'text-green-500',
          ]"
        >
          {{ displayPercentage }}%
        </span>
        from the previous period
      </div>
    </div>
    <div
      ref="totalEmissionsChart"
      class="shrink basis-1/2 overflow-hidden"
    >
      <apex-chart
        ref="scopesChartTotal"
        height="100%"
        :options="totalEmissionsChartOptions"
        :series="totalEmissionsChartSeries"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'TotalEmissionsCard',

  props: {
    emissions: {
      type: Number,
      required: true,
    },
    metricsChange: {
      type: [Number, String],
      required: true,
    },
    chartSeries: {
      type: Array,
      required: true,
    },
    labels: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      totalEmissions: thousands(this.emissions, 3),
      previousYearMetricsChange: this.metricsChange,
      totalEmissionsChartSeries: this.chartSeries,
      totalEmissionsChartOptions: {
        colors: ['#8BB700'],
        legend: {
          show: false,
        },
        grid: {
          show: false,
        },
        chart: {
          toolbar: {
            show: false,
          },
          height: 100,
          width: window.innerWidth > 1536 ? 300 : 200,
          type: 'area',
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: 'smooth',
        },
        labels: this.labels,
        xaxis: {
          labels: {
            show: false,
          },
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
        },
        yaxis: {
          labels: {
            show: false,
          },
          axisBorder: {
            show: false,
          },
        },
        tooltip: {
          y: {
            formatter(val) {
              return `${thousands(val, 3)} tCO2e`
            },
          },
        },
      },
    }
  },

  computed: {
    displayPercentage() {
      return `${this.previousYearMetricsChange !== 0 ? thousands(this.previousYearMetricsChange) : this.previousYearMetricsChange}`
    },
  },

  watch: {
    emissions(newTotal) {
      this.totalEmissions = thousands(newTotal)
    },
    metricsChange(newChange) {
      this.previousYearMetricsChange = newChange
    },
    chartSeries(newSeries) {
      this.totalEmissionsChartSeries = newSeries
    },
    labels(newLabels) {
      this.totalEmissionsChartOptions.xaxis.categories = newLabels
      this.$refs.scopesChartTotal.updateOptions(
        this.totalEmissionsChartOptions,
      )
    },
  },
}
</script>
